(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-product-buy')) {
    customElements.define(
      'sticky-product-buy',
      class StickyProductBuy extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.mainButton = document.querySelector(`#product-form-${this.sectionId} button[name="add"]`);
          this.stickyButton = this.querySelector('.sticky-product-buy__button');
          this.price = this.querySelector('.sticky-product-buy__price');
          this.footer = document.querySelector('footer');

          if (!this.mainButton || !this.stickyButton) return;

          this.onStickyClick = () => {
            if (!this.mainButton.disabled) this.mainButton.click();
          };
          this.onViewportChange = () => this.updateVisibility();
          this.stickyButton.addEventListener('click', this.onStickyClick);
          window.addEventListener('scroll', this.onViewportChange, { passive: true });
          window.addEventListener('resize', this.onViewportChange);

          this.syncObserver = new MutationObserver(() => this.sync());
          this.syncObserver.observe(this.mainButton, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
          });

          const priceContainer = document.querySelector(`#price-${this.sectionId}`);
          if (priceContainer) {
            this.priceObserver = new MutationObserver(() => this.sync());
            this.priceObserver.observe(priceContainer, {
              attributes: true,
              childList: true,
              subtree: true,
              characterData: true
            });
          }

          this.sync();
          this.updateVisibility();
        }

        disconnectedCallback() {
          this.stickyButton?.removeEventListener('click', this.onStickyClick);
          window.removeEventListener('scroll', this.onViewportChange);
          window.removeEventListener('resize', this.onViewportChange);
          this.syncObserver?.disconnect();
          this.priceObserver?.disconnect();
        }

        sync() {
          const mainLabel = this.mainButton?.querySelector('span');
          const stickyLabel = this.stickyButton?.querySelector('span');
          if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent.trim();
          if (this.mainButton && this.stickyButton) this.stickyButton.disabled = this.mainButton.disabled;

          const priceItems = document.querySelectorAll(`#price-${this.sectionId} .price-item`);
          const visiblePrice = Array.from(priceItems).find((item) => item.offsetParent !== null);
          if (visiblePrice && this.price) this.price.textContent = visiblePrice.textContent.trim();
        }

        updateVisibility() {
          if (!this.mainButton || window.matchMedia('(min-width: 750px)').matches) {
            this.hidden = true;
            return;
          }

          const purchaseButtonPassed = this.mainButton.getBoundingClientRect().bottom < 0;
          const footerVisible = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
          this.hidden = !purchaseButtonPassed || footerVisible;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
